export default __webpack_public_path__ + "static/media/almond.50901486.webp";